/**
 * author: Soumya Shreyas
 * Modal Component for confirmation
 */

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

function ConfirmationModal({ t, modalShow, messageText, callbackModal, id = "", title = "", confirmBtn = t("Ok.label"), CancelBtn = t("Cancel.label"), type }) {
  const [show, setShow] = useState(modalShow);
  const [message, setMessage] = useState(messageText);

  const handleClose = () => {
    setShow(false);
    callbackModal(false, id);

  }
  const handleConfirm = () => {
    setShow(false);
    callbackModal(true, id);
  };

  return (
    <Modal show={show} onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      size={type === 'Double_Materiality' || type === 'Scorecard' || type ==='GenerateReport' ? "md" : 'sm'}
      centered backdrop="static"
      keyboard={false}>
      <Modal.Header className="border-0" closeButton>
        <Modal.Title as="h5">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center justify-content-center shortDataHeight">
          {message}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="px-3" onClick={handleClose} autoFocus>
          {CancelBtn}
        </Button>
        <Button variant="primary" onClick={handleConfirm} className="px-3">
          {confirmBtn}
        </Button>
      </Modal.Footer>
    </Modal >
  );
}

export default withTranslation()(ConfirmationModal);
